import { z } from "zod"

// Version 1 ---------------------
export const HTMLSettingsV1 = z.object({
  value: z.string(),
})

export type THTMLSettingsV1 = z.infer<typeof HTMLSettingsV1>

export const HTMLElementV1 = z.object({
  id: z.string(),
  name: z.literal("html"),
  settings: HTMLSettingsV1,
})

export type THTMLElementV1 = z.infer<typeof HTMLElementV1>

// Latest ---------------------
export const HTMLSettings = HTMLSettingsV1
export type THTMLSettings = THTMLSettingsV1
export const HTMLElement = HTMLElementV1
export type THTMLElement = THTMLElementV1
